<div
  [id]="identifier"
  class="toolbar-widget widget widget--is-docked"
  (mousedown)="onMouseDown()"
  #widgetWrapper
>
  <div class="widget__inner">
    <div
      class="widget__header"
      [ngClass]="
        this.state === 2 || this.state === 3
          ? 'widget__header--undocked'
          : 'widget__header--docked'
      "
    >
      <div class="widget__header__label">
        <ng-container
          *ngIf="widgetType.hasAppIcon() || widgetType.hasMaterialIcon()"
        >
          <mat-icon
            fontSet="material-icons-outlined"
            *ngIf="widgetType.hasMaterialIcon()"
          >
            {{ widgetType.getIconName() }}
          </mat-icon>
          <app-asset-icon
            [icon]="widgetType.getIconName()"
            *ngIf="widgetType.hasAppIcon()"
          ></app-asset-icon>
        </ng-container>
        <h3
          class="widget__title"
          [translate]="'widgets.' + widgetName + '.name'"
        >
          Widget Title
        </h3>
      </div>
      <div class="widget__header__actions">
        <button
          mat-flat-button
          class="widget__header__button"
          (click)="onDockButtonClicked()"
          matTooltip="Dock"
          matTooltipPosition="above"
          aria-label="Dock"
          *ngIf="this.state === 2 || this.state === 3"
        >
          <app-asset-icon icon="dock"></app-asset-icon>
        </button>
        <button
          mat-flat-button
          class="widget__header__button"
          (click)="onCloseButtonClicked()"
          matTooltip="Close"
          matTooltipPosition="above"
          aria-label="Close"
          mat-flat-button
        >
          <mat-icon
            class="widget__header-button--close"
            fontSet="material-icons-outlined"
            >close</mat-icon
          >
        </button>
      </div>
    </div>

    <div class="widget__content">
      <ng-template #widgetInsertionPoint></ng-template>
    </div>
  </div>

  <div class="widget__resizer" *ngIf="this.state === 2 || this.state === 3">
    <mat-icon>code</mat-icon>
  </div>
</div>
